import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Fintech software development services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What is fintech?',
      description: `
        A: Fintech—short for financial technology—refers to the integration of 
        technology into offerings by financial services companies to improve 
        their use and delivery to consumers. It represents a rapidly growing 
        industry that uses technology to enhance financial activities. The 
        primary goal of fintech is to make financial services more accessible, 
        efficient, and user-friendly, leveraging innovations like mobile apps, 
        artificial intelligence, blockchain, and big data.
      `,
      gradientOnFocus: theme.mixins.emeraldGradient?.background as string,
    },

    {
      title:
        'Q: What type of fintech development services does Rumble Fish offer?',
      description: `
        A: At Rumble Fish, we develop a comprehensive range of fintech 
        solutions designed to meet the diverse needs of the financial industry. 
        Our expertise spans across various domains, ensuring that we can 
        deliver tailored solutions to enhance efficiency, security, and user 
        experience. Here are the key types of fintech solutions we offer:
        <ul>
          <li>Custom Fintech Software Development Services</li>
          <li>Payment Solutions Development Services</li>
          <li>Banking Software Development Services</li>
          <li>Investment and Trading Platforms Development Services</li>
        </ul>
      `,
      gradientOnFocus: theme.mixins.aquamarineGradient?.background as string,
    },
    {
      title: `
        Q: Can Rumble Fish develop fintech applications for both web and 
        mobile platforms?
      `,
      description: `
        A: Yes, at Rumble Fish, we specialize in developing fintech 
        applications for both web and mobile platforms. Our team of experienced 
        developers is proficient in a wide range of technologies and 
        frameworks, allowing us to create seamless and responsive applications 
        that offer consistent user experiences across devices.
        <br />
        <br />
        Whether you need a web-based fintech portal, a native mobile banking 
        app, or a cross-platform payment solution, Rumble Fish has the 
        expertise and capabilities to deliver customized fintech applications 
        that meet your specific requirements and exceed your expectations. 
        With our comprehensive development services, you can reach a broader 
        audience, enhance customer engagement, and stay ahead of the 
        competition in the rapidly evolving fintech landscape.
      `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'Q: Why hire Rumble Fish for fintech product development?',
      description: `
        A: With Rumble Fish as your fintech product development company, you 
        can rest assured that you're in good hands. We bring together the right 
        mix of expertise, technology, and commitment to help you create 
        innovative fintech products that drive growth, enhance customer 
        satisfaction, and position you for long-term success in the 
        ever-evolving financial landscape. What we bring to the table:
        <br />
        <ul>
          <li>
            <b>Expertise: </b>
            Rumble Fish boasts a team of seasoned professionals with extensive 
            experience in fintech product development. Our developers, 
            designers, and strategists have a deep understanding of the 
            financial industry and the technological landscape, allowing us to 
            create innovative solutions that address your specific needs 
            and challenges.
          </li>
          <li>
            <b>Customization: </b>
            We understand that every fintech product is unique, and one size 
            does not fit all. That's why we take a personalized approach to 
            product development, tailoring our solutions to meet your exact 
            requirements and objectives. Whether you need a payment gateway, 
            a mobile banking app, or a blockchain-based solution, we have the 
            expertise to bring your vision to life.
          </li>
          <li>
            <b>Cutting-Edge Technology: </b>
            At Rumble Fish, we stay ahead of the curve when it comes to 
            technology. From blockchain and artificial intelligence to cloud 
            computing and data analytics, we leverage the latest tools and 
            techniques to build state-of-the-art fintech products that are 
            secure, scalable, and future-proof.
          </li>
          <li>
            <b>Security and Compliance: </b>
            Security and compliance are top priorities for us when developing 
            fintech products. We follow industry best practices and adhere to 
            strict security standards to ensure that your data and transactions 
            are protected at all times. Additionally, we stay up-to-date with 
            regulatory requirements to ensure that your product remains 
            compliant with relevant laws and regulations.
          </li>
          <li>
            <b>User Experience: </b>
            We believe that great user experience is essential for the success 
            of any fintech product. That's why we place a strong emphasis on 
            usability, accessibility, and intuitiveness when designing and 
            developing our solutions. Our goal is to create products that are 
            not only functional but also delightful to use, resulting in 
            higher user satisfaction and engagement.
          </li>
          <li>
            <b>Collaborative Approach: </b>
            We see ourselves as your partners in success, not just your 
            vendors. Throughout the development process, we maintain open lines 
            of communication and collaborate closely with you to ensure that 
            your vision is realized. We welcome feedback and iteration, and we 
            work tirelessly to deliver results that exceed your expectations.
          </li>
        </ul>
      `,
      gradientOnFocus: theme.mixins.raspberryGradient?.background as string,
    },
  ];
};
